import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Space, Alert, Select } from 'antd';
import { useNavigate, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { createChatQuestion, getChatQuestionById } from '../../store/slices/chatQuestionSlice';

const EditChatQuestion = () => {
    const { id } = useParams();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const chatQuestion = useSelector((state) => state?.chatQuestion?.chatQuestion)
    useEffect(() => {
        dispatch(getChatQuestionById(id))
    }, [dispatch])
    useEffect(() => {
        if (form) {
            form.setFieldsValue({
                question: chatQuestion?.data?.question,
                type: chatQuestion?.data?.type,
            })
        }
    }, [form, chatQuestion])
    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            let data = {
                ...values,
                id
            }
            const resultAction = await dispatch(createChatQuestion(data))

            if (createChatQuestion.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'Chat question updated successfully');
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('')
                }, 4000)
            } else {
                console.log(resultAction?.payload)
                setAlertMessage(resultAction?.payload?.error || 'Error updating chat question');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error updating chat question.');
            setAlertType('error');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Agent</h1>
            <Card title="Edit Chat Question" style={{ marginBottom: 16 }}>
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                    form={form}
                >
                    <Form.Item
                        label="Question"
                        name="question"
                        rules={[{ required: true, message: 'Please input question!' }]}
                    >
                        <Input placeholder="Enter question" />
                    </Form.Item>
                    <Form.Item
                        label="Type"
                        name="type"
                        rules={[
                            { required: true, message: 'Please select type' },
                        ]}
                    >
                        <Select
                            options={[
                                { value: '', disabled : true, label: <span>Select Type</span> },
                                { value: 'user', label: <span>User</span> },
                                { value: 'agent', label: <span>Agent</span> },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button onClick={(e) => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default EditChatQuestion;